<template>
  <div class="text-block p-28 bg--color-01 sha--03 bor--radius-12">
    <h3 class="txt--bold txt--color-04 txt--22px txt--height-30px mb-16">
      {{ title }}
    </h3>
    <div v-if="text">
      <slot name="extraText" />
      <p
        :class="{ 'mt-20': $slots.extraText }"
        class="txt--color-03 txt--16px txt--height-28px mb-0"
        v-html="text"
      />
    </div>
    <slot v-else />
  </div>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
  },
}
</script>
